module.exports = __webpack_public_path__ + "img/gagneux brunon.67acd7af.jpg";